(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-refine"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initCarousel = (section) => {
    const wrapper = section.querySelector('.featured-products__track-wrapper');
    const item = section.querySelector('.featured-products__item');
    const prev = section.querySelector('.featured-products__arrow.prev');
    const next = section.querySelector('.featured-products__arrow.next');
    if (!wrapper || !item || !prev || !next) return;

    const scrollStep = item.offsetWidth + 24;
    let autoScroll;

    const maxScroll = () => wrapper.scrollWidth - wrapper.clientWidth;

    const moveNext = () => {
      const current = Math.round(wrapper.scrollLeft);
      const maxLeft = Math.round(maxScroll());
      // 🧩 Corrección: evita el espacio en blanco del final
      if (current >= maxLeft - 1) {
        wrapper.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        wrapper.scrollBy({ left: scrollStep, behavior: 'smooth' });
      }
    };

    const movePrev = () => {
      const current = Math.round(wrapper.scrollLeft);
      const maxLeft = Math.round(maxScroll());
      if (current <= 0) {
        wrapper.scrollTo({ left: maxLeft, behavior: 'smooth' });
      } else {
        wrapper.scrollBy({ left: -scrollStep, behavior: 'smooth' });
      }
    };

    // 🔘 Botones
    prev.addEventListener('click', () => {
      movePrev();
      restartAuto();
    });
    next.addEventListener('click', () => {
      moveNext();
      restartAuto();
    });

    // 🔁 Auto-scroll cada 4 segundos
    const startAuto = () => {
      autoScroll = setInterval(moveNext, 4000);
    };
    const stopAuto = () => clearInterval(autoScroll);
    const restartAuto = () => {
      stopAuto();
      startAuto();
    };

    // Pausa con hover o touch
    wrapper.addEventListener('mouseenter', stopAuto);
    wrapper.addEventListener('mouseleave', startAuto);
    wrapper.addEventListener('touchstart', stopAuto);
    wrapper.addEventListener('touchend', startAuto);

    // 🚀 Iniciar
    startAuto();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.featured-products-section').forEach(initCarousel);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initCarousel(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
